import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { DataService } from '../../../shared/services/data.service';

@Injectable({
  providedIn: 'root'
})
export class LoginService {

  constructor(private http: HttpClient, private dataService: DataService) {
  }

  login(username: string, password: string) {
    let url = sessionStorage.getItem('apiUrl') + 'config_portal/login/';
    return this.http.post(url, { 'email': username, 'password': password }).pipe(map(
      (response: any) => {
        return response;
      }
    ));
  }

  twoFactType(username: string, mode: string) {
    let url = sessionStorage.getItem('apiUrl') + 'accounts/select_auth/';
    return this.http.post(url, { 'username': username, 'authtype': mode }).pipe(map(
      response => {
        return response;
      }
    ));
  }

  validateEmailSecurityCode(username: string, securityCode: number | null) {
    let url = sessionStorage.getItem('apiUrl') + 'accounts/validate_otp/';
    return this.http.post(url, { 'username': username, 'otp': securityCode }).pipe(map(
      response => {
        return response;
      }
    ));
  }

  validateQrSecurityCode(username: string, securityCode: number | null = null) {
    let url = sessionStorage.getItem('apiUrl') + 'accounts/validate_qr_otp/';
    return this.http.post(url, { 'username': username, 'otp': securityCode }).pipe(map(
      response => {
        return response;
      }
    ));
  }

  getSSOURL() {
    let url = sessionStorage.getItem('apiUrl') + 'accounts/get_sso_url';
    return this.http.get(url).pipe(map(
      response => {
        return response;
      }
    ));
  }

  logout() {
    let url = sessionStorage.getItem('apiUrl') + 'accounts/logout';
    return this.http.get(url).pipe(map(
      response => {
        return response;
      }
    ));
  }

  changePassword(emailId: string, currentPassword: string, newPassword: string, confirmNewPassword: string) {
    let url = sessionStorage.getItem('apiUrl') + 'accounts/change_password';
    return this.http.post(url, { 'username': emailId, 'old_password': currentPassword, 'new_password1': newPassword, 'new_password2': confirmNewPassword }).pipe(map(
      response => {
        return response;
      }
    ));
  }

  forgotPassword(email) {
    let url = sessionStorage.getItem('apiUrl') + 'accounts/resetpass/';
    return this.http.post(url, email).pipe(map(
      response => {
        return response;
      }
    ));
  }

  clearData() {
    let url: any = sessionStorage.getItem('url');
    let apiUrl: any = sessionStorage.getItem('apiUrl');
    let wsUrl: any = sessionStorage.getItem('websocketUrl');
    sessionStorage.clear();
    sessionStorage.clear();
    sessionStorage.setItem('url', url);
    sessionStorage.setItem('apiUrl', apiUrl);
    sessionStorage.setItem('wsUrl', wsUrl);
    this.dataService.passLoggedIn(false, true);
  }

  isLoggedIn() {
    let isLoggedIn: any = sessionStorage.getItem('loggedIn');
    if (sessionStorage.getItem('token') && JSON.parse(isLoggedIn)) {
      // sessionStorage.setItem('redirectUrl', '');
      return true;
    }
    else {
      sessionStorage.setItem('redirectUrl', window.location.href);
      return false;
    }
  }

  updateTermsConditions(termsValue: boolean) {
    let url = sessionStorage.getItem('apiUrl') + 'accounts/update_tc_details/';
    return this.http.post(url, { 'tc_accepted': termsValue }).pipe(map(
      response => {
        return response;
      }
    ));
  }

  notificationPost(dataObj) {
    let url = sessionStorage.getItem('apiUrl') + 'config_module/email_sms_configuration/';
    return this.http.post(url, dataObj).pipe(map(
      response => {
        return response;
      }
    ));
  }
  notificationget() {
    let url = sessionStorage.getItem('apiUrl') + 'config_module/email_sms_configuration/';
    return this.http.get(url).pipe(map(
      response => {
        return response;
      }
    ));
  }

}
